export * from './user-button.component';
export * from './user-dialog.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/user-button/index.ts